export { DietaryRestrictionsScreen } from './DietaryRestrictionsScreen';
